<template>
	<div>
		<q-table
			:data="comments"
			:columns="columns"
			:pagination.sync="server_pagination"
			:loading="loading"
			row-key="id"
			:no-data-label="$t('no_data_avaliable')"
			:no-results-label="$t('no_results_found')"
			:loading-label="$t('loading_data')"
			:rows-per-page-label="$t('items_per_page')"
			:rows-per-page-options="[0]"
			binary-state-sort
			class="q-mt-md"
		>
			<q-tr slot="header" slot-scope="props" :props="props">
				<q-th v-for="col in props.cols" :key="col.name" :props="props" v-if="col.show">
					{{ $t(col.label) }}
				</q-th>
			</q-tr>

			<q-tr slot="body" slot-scope="props" :props="props">
				<q-td auto-width key="id" :props="props">
					{{ props.row.id }}
				</q-td>

				<q-td key="user" :props="props">
					{{ props.row.user }}
				</q-td>

				<q-td key="stars" :props="props" v-if="origin !== 'news' ? true : false">
					<q-rating
						color="amber"
						icon="fas fa-star"
						v-model="props.row.stars"
						:max="5"
						readonly
					/>
				</q-td>

				<q-td key="comment" :props="props">
					{{ props.row.comment ? $truncateLink(props.row.comment) : props.row.comment }}
				</q-td>

				<q-td auto-width key="status" :props="props">
					<q-chip
						small
						:icon="getIconStatus(props.row.status)"
						:color="getColorStatus(props.row.status)"
						class="full-width"
					>
						{{ $t(getStatus(props.row.status)) }}
					</q-chip>
				</q-td>

				<q-td key="actions" :props="props">
					<q-btn
						flat
						round
						color="primary"
						icon="far fa-pencil-alt"
						@click="editComment(props.row)"
						:disable="manager"
					/>
				</q-td>
			</q-tr>
		</q-table>

		<q-modal
			v-model="show_edit_comment"
			:content-css="{ minWidth: getMinWidth, maxWidth: getMaxWidth, minHeight: '80vh' }"
			no-backdrop-dismiss
			no-esc-dismiss
		>
			<q-modal-layout>
				<q-toolbar slot="header">
					<q-btn
						flat
						round
						dense
						@click="show_edit_comment = false"
						icon="fas fa-times"
					/>
					<q-toolbar-title>
						{{ $t('comments') }}
					</q-toolbar-title>
				</q-toolbar>

				<div class="layout-padding">
					<div class="row gutter-sm">
						<div class="col-12">
							<q-input
								v-model="comment.comment"
								:float-label="$t('comment')"
								disable
							/>
						</div>

						<div class="col-12">
							<q-input v-model="comment.user" :float-label="$t('author')" disable />
						</div>

						<div class="col-12">
							<q-select
								v-model="comment.status"
								:options="status_list"
								:float-label="$t('status')"
							/>
						</div>
					</div>

					<div class="row gutter-sm justify-end q-mt-lg">
						<div class="col-xs-12 col-sm-3" :class="getOrder('cancel')">
							<q-btn
								color="tertiary"
								class="full-width"
								:label="$t('back')"
								icon="far fa-block"
								@click="show_edit_comment = false"
							/>
						</div>

						<div class="col-xs-12 col-sm-3" :class="getOrder('save')">
							<q-btn
								color="secondary"
								class="full-width"
								:label="$t('save')"
								icon="far fa-save"
								@click="saveComment()"
							/>
						</div>
					</div>
				</div>
			</q-modal-layout>
		</q-modal>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
	props: {
		origin: {
			type: String,
		},
		manager: {
			type: Boolean,
			default: false,
		},
		presential_status: {
			type: Number,
		},
	},

	data() {
		return {
			id: '',
			server_pagination: {
				page: 1,
				rowsNumber: 10,
				rowsPerPage: 0,
				descending: false,
				sortBy: null,
			},
			comments: [],
			columns: [
				{
					name: 'id',
					required: true,
					label: '#',
					align: 'left',
					field: 'id',
					sortable: true,
					show: true,
				},
				{
					name: 'user',
					required: true,
					label: 'author',
					align: 'left',
					field: 'user',
					sortable: true,
					show: true,
				},
				{
					name: 'stars',
					required: true,
					label: 'stars',
					align: 'left',
					field: 'stars',
					sortable: true,
					show: this.origin !== 'news' ? true : false,
				},
				{
					name: 'comment',
					required: true,
					label: 'comment',
					align: 'left',
					field: 'comment',
					sortable: true,
					show: true,
				},
				{
					name: 'status',
					required: true,
					label: 'status',
					align: 'left',
					field: 'status',
					sortable: true,
					show: true,
				},
				{
					name: 'actions',
					required: true,
					label: '',
					align: 'right',
					field: 'edit',
					sortable: false,
					show: true,
				},
			],
			loading: false,
			comment: {},
			show_edit_comment: false,
			status_list: [
				{ value: 1, label: this.$t('published') },
				{ value: 2, label: this.$t('unpublished') },
				{ value: 3, label: this.$t('deleted') },
			],
		}
	},

	computed: {
		...mapGetters({
			access_token: 'common/access_token',
		}),

		getHeader() {
			return {
				headers: {
					'content-type': 'application/json',
					authorization:
						'Basic ' +
						btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
					authorization: 'Bearer ' + this.access_token,
				},
			}
		},

		getMaxWidth() {
			if (this.$q.platform.is.mobile) return '100vw'
			else return '80vw'
		},

		getMinWidth() {
			if (!this.$q.platform.is.mobile) return '90vw'
		},
	},

	methods: {
		fetchComments({ pagination }) {
			this.loading = true
			this.server_pagination = pagination

			let order = pagination.descending ? '-' : ''
			let order_by = pagination.sortBy ? order + pagination.sortBy : ''

			let data = {
				page_size: this.server_pagination.rowsPerPage,
				page: this.server_pagination.page,
				search: '',
				ordering: order_by,
			}

			let url_api = ''

			if (this.origin === 'training')
				url_api = `/admin_group_trainings/group_trainings/${this.id}/comments/`
			else if (this.origin === 'trail') url_api = `/admin_trails/trails/${this.id}/comments/`
			else if (this.origin === 'trails')
				url_api = `/admin_trails/trails/${this.id}/trail_user_stars/`
			else if (this.origin === 'news') url_api = `/admin_news/news/${this.id}/comments/`
			else if (this.origin === 'podcast')
				url_api = `/admin_podcast/podcasts/${this.id}/comments/`
			else if (this.origin === 'presential')
				url_api = `/presential/presential_events/${this.id}/comments/`
			else if (this.origin === 'webcast')
				url_api = `/admin_webcasts/webcasts/${this.id}/comments/`
			else if (this.origin === 'live_class')
				url_api = `/admin_live_classes/live_classes/${this.id}/comments/`

			this.$axios
				.get(url_api, this.getHeader)
				.then((response) => {
					this.server_pagination.rowsNumber = response.data.length

					this.comments = response.data.map((e) => {
						return {
							...e,
							actions: e.id,
						}
					})
				})
				.catch((e) => {
					console.log(e)
				})
				.finally(() => {
					this.loading = false
				})
		},

		editComment(props) {
			this.comment = props
			this.show_edit_comment = true
		},

		saveComment() {
			this.$q.loading.show()

			let fd = new FormData()
			fd.append('status', this.comment.status)
			fd.append('id', this.comment.id)

			let url_api = ''

			if (this.origin === 'training')
				url_api = `/admin_group_trainings/group_trainings/${this.id}/publish_comment/`
			else if (this.origin === 'trail')
				url_api = `/admin_trails/trails/${this.id}/publish_comment/`
			else if (this.origin === 'news')
				url_api = `/admin_news/news/${this.id}/publish_comment/`
			else if (this.origin === 'podcast')
				url_api = `admin_podcast/podcasts/${this.id}/publish_comment/`
			else if (this.origin === 'presential')
				url_api = `presential/presential_events/${this.id}/publish_comment/`

			this.$axios
				.post(url_api, fd, this.getHeader)
				.then((response) => {
					this.fetchComments({
						pagination: {
							page: 1,
							rowsNumber: 10,
							rowsPerPage: 0,
							descending: false,
							sortBy: null,
						},
					})

					this.show_edit_comment = false
				})
				.catch((e) => {
					console.log(e)
				})
				.finally(() => {
					this.$q.loading.hide()
				})
		},

		getStatus(status) {
			if (status == 1) return 'published'
			else if (status == 2) return 'unpublished'
			else if (status == 3) return 'deleted'
		},

		getIconStatus(status) {
			if (status == 1) return 'fas fa-check'
			else if (status == 2) return 'fas fa-ban'
			else if (status == 3) return 'fas fa-trash-alt'
		},

		getColorStatus(status) {
			if (status == 1) return 'positive'
			else if (status == 2) return 'warning'
			else if (status == 3) return 'negative'
		},

		getOrder(name) {
			if (name == 'cancel') {
				if (this.$q.platform.is.mobile) return 'order-last'
				else return 'order-first'
			} else if (name == 'save') {
				if (this.$q.platform.is.mobile) return 'order-first'
				else return 'order-last'
			}
		},
	},

	created() {
		this.id = this.$route.params.id
		this.fetchComments({
			pagination: this.server_pagination,
		})
	},
}
</script>

<style></style>
